module.exports = __webpack_public_path__ + "img/shangjiashishi.e75a4821.jpg";